import { Button, Form, Modal } from "react-bootstrap"
import { allUserNotice, userNotice } from "../../../Services/AdminServices/userSaleServices"
import { useEffect, useState } from "react"
import toast from "react-hot-toast";
import DataTables from "../../Main/DataTable/DataTables";
import Loader from "../../Main/Loader";
import { FaPlus } from "react-icons/fa";

const UserNotification = () => {

    const columns = [
        { name: 'Title', selector: row => row.title },
        {
            name: 'Description',
            cell: row => <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', paddingTop: "5px", paddingBottom: "5px" }}>{row.description}</div>,
            grow: 2 // Optional: to give it more width
        },
        { name: 'Created At', selector: row => row.created_at },
        {
            name: 'Status',
            selector: row => row?.status === "active" ? (
                <h6 className='mb-0'><span className="badge bg-success">{row?.status}</span></h6>
            ) : (
                <h6 className='mb-0'><span className="badge bg-danger">{row?.status}</span></h6>
            )
        }
    ];


    const [title, setTitle] = useState("");
    const [description, setDesctription] = useState("");
    const [allNotification, setAllNotification] = useState([]);
    const handleTitle = (e) => { setTitle(e.target.value) }
    const handleDescription = (e) => { setDesctription(e.target.value) }
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const handlePostMessage = async (e) => {
        e.preventDefault();
        setLoading(true)
        let body = {
            title, description
        }
        let response = await userNotice(body);
        if (response?.code === 201) {
            toast.success(response?.message)
            setDesctription("")
            setTitle("")
            setShow(false)
            setLoading(false)
            handleGetMessage();
        }
        else if (response?.code != 201) {
            toast.error(response?.error)
            setLoading(false)
        }
        setLoading(false)
    }

    const handleGetMessage = async (e) => {
        setLoading(true)
        let response = await allUserNotice();
        if (response?.code === 200) {
            setAllNotification(response?.result?.data)
            setLoading(false)
        }
        else if (response?.code != 200) {
            toast.error(response?.error)
            setLoading(false)
        }
        setLoading(false)
    }

    useEffect(() => { handleGetMessage(); }, [])

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg">
                        <h3 className='fw-bold mb-0'>Notification</h3>
                        <p className='text-muted'>Manage Notification For Refferrals </p>
                    </div>

                    <div className="col-auto">
                        <Button variant="primary" size="sm" onClick={handleShow}>
                            <FaPlus />
                        </Button>
                    </div>


                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-12">
                            <DataTables filter={true} columns={columns} data={allNotification} />
                        </div>
                    )}


                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Message</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form >
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control value={title} onChange={handleTitle} type="text" placeholder="Notice title here" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="notice">
                                    <Form.Label>Notice</Form.Label>
                                    <Form.Control value={description} onChange={handleDescription} as="textarea" placeholder="Notice message here" rows={3} />
                                </Form.Group>

                                {/* 
                                <div className="text-end">
                                    <Button variant="primary" className="px-4 py-2 rounded-1" type="submit">Submit</Button>
                                </div> */}
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={handlePostMessage}>
                                {loading ? <Loader /> : "Save"}
                            </Button>
                        </Modal.Footer>
                    </Modal>






                </div>
            </div>
        </>
    )
}

export default UserNotification